module.exports = __webpack_public_path__ + "ClientApp/images/link-icons/dog.svg";